import { ChartType, MapChartLocation, MapChartType, } from '../../../../../../types/savedCharts';
export const getHeatmapChartConfig = ({ queryTool, metricQuery, }) => {
    const { chartConfig } = queryTool;
    const [firstDimension, secondDimension] = queryTool.queryConfig.dimensions;
    return {
        type: ChartType.MAP,
        config: {
            mapType: chartConfig?.mapType ?? MapChartLocation.WORLD,
            locationType: MapChartType.HEATMAP,
            latitudeFieldId: chartConfig?.mapLatitudeFieldId ?? firstDimension,
            longitudeFieldId: chartConfig?.mapLongitudeFieldId ?? secondDimension,
            valueFieldId: chartConfig?.mapValueFieldId ??
                chartConfig?.yAxisMetrics?.[0] ??
                metricQuery.metrics[0],
            heatmapConfig: {
                radius: chartConfig?.heatmapRadius ?? undefined,
                blur: chartConfig?.heatmapBlur ?? undefined,
                opacity: chartConfig?.heatmapOpacity ?? undefined,
            },
        },
    };
};
//# sourceMappingURL=heatmap.js.map